export const getError = (error) => {
  return error.response && error.response.data.massage
    ? error.response.data.massage
    : error.message;
};
